export default __webpack_public_path__ + "static/media/contact_light_mode.229a0f7c.svg";